import { render, staticRenderFns } from "./ButtonAction.vue?vue&type=template&id=5667de4a&scoped=true"
import script from "./ButtonAction.vue?vue&type=script&lang=ts"
export * from "./ButtonAction.vue?vue&type=script&lang=ts"
import style0 from "./ButtonAction.vue?vue&type=style&index=0&id=5667de4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5667de4a",
  null
  
)

export default component.exports